import React from "react";
import ChatTab from "./ChatTab";
import { useLanguage } from "../utils/i18n";

export default function GeneralChatPage({ onBack, api, notes, onAddNote }) {
  const { t } = useLanguage();
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "var(--bg)" }}>
      {/* Header */}
      <header style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "0 20px",
        height: "60px",
        background: "#ffffff",
        borderBottom: "1px solid var(--border)",
        flexShrink: 0,
      }}>
        <button
          onClick={onBack}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "var(--text-secondary)",
            fontSize: "0.9rem",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "6px 10px",
            borderRadius: "8px",
            transition: "background 0.15s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "var(--primary-light)"}
          onMouseLeave={e => e.currentTarget.style.background = "none"}
        >
          {t("backHome")}
        </button>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 700, fontSize: "1rem", color: "var(--text)" }}>
            MIL<span style={{ color: "#ff69b4" }}>A</span>
          </span>
        </div>
        <span style={{ color: "var(--border)", fontSize: "1.2rem", lineHeight: 1 }}>|</span>
        <span style={{ color: "var(--text-secondary)", fontSize: "0.95rem", fontWeight: 500 }}>{t("generalChat")}</span>
      </header>

      {/* Chat area — centered column */}
      <div style={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
      }}>
        <div style={{
          width: "100%",
          maxWidth: "820px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          background: "#ffffff",
          borderLeft: "1px solid var(--border)",
          borderRight: "1px solid var(--border)",
        }}>
          <ChatTab book={null} api={api} onAddNote={onAddNote} />
        </div>
      </div>
    </div>
  );
}
